export const SERVER_URL = 'https://backend.ptmcambodia.com'
export const API_BASE_URL = `${SERVER_URL}/api`